export default {
  name: "InfoSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 30a14 14 0 1 0 0-28 14 14 0 0 0 0 28zm0-22a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-1.5 6.5a1.5 1.5 0 1 1 3 0v8a1.5 1.5 0 1 1-3 0v-8z",
  },
}
